import React from 'react'
import { useState } from 'react';
import { IoIosArrowForward } from "react-icons/io";
import { IoIosArrowDropleft } from "react-icons/io";
import { RiCollapseDiagonalLine } from "react-icons/ri";
import { IoIosArrowDown } from "react-icons/io";
import { IoIosArrowUp } from "react-icons/io";
import { FaFilter } from "react-icons/fa";
import { TbReload } from "react-icons/tb";
import { TbArrowsSort } from "react-icons/tb";
import { FaPlus } from "react-icons/fa";
import AdduserModal from './adduserModal';


function DomainSmartLink() {

    const [showfilter, setshowfilter] = useState(false);
    const [DomainName, setDomainName] = useState('')
    const [DomainProvider, setDomainProvider] = useState('')
    const [Domaintype, setDomaintype] = useState('')
    const [open, setOpen] = useState(false);
    const [NewDomainName, setNewDomainName] = useState('')
    const [NewDomainProvider, setNewDomainProvider] = useState('')
    const [isActive, setisActive] = useState(false);





    function getdata() {
        console.log(DomainName, DomainProvider, Domaintype)
    }
    return (
        <>
            <div className='pt-[70px] dark:bg-[#121519]  min-h-screen px-4'>
                <div className='border-b-[1px] border-[#cfcdcd] pb-1 flex items-center gap-2 '>
                    <IoIosArrowDropleft className='text-[36px]' />
                    <div>
                        <h1 className='text-[#000] font-semibold text-[20px] dark:text-[#fff]'>Domain URL</h1>
                        <div className='text-[#454546] dark:text-[#fff] text-[12px] font-semibold flex items-center cursor-pointer'>  <span>Home</span> <IoIosArrowForward />
                            <span>URL</span><IoIosArrowForward /> <span>Domain URL</span>  </div>
                    </div>
                </div>
                <div className='w-[100%] flex items-center justify-between py-2'>
                    <input type="date" name="" id=""
                        className='border-[1px] border-[#3f7fca] text-[#3f7fca]    text-[12px] font-semibold rounded-md p-1 '
                        placeholder='Date Range'
                    />
                    <button
                        onClick={() => {
                            setOpen(!open)
                        }}
                        className='border-[1px] border-[#3f7fca] text-[#3f7fca] py-2 px-3 flex items-center justify-center gap-1 hover:bg-[#3f7fca] hover:text-[#fff] rounded-md text-[12px] font-semibold mt-4'> <FaPlus /> Add Template</button>
                </div>
                <div onClick={() => setshowfilter(!showfilter)}
                    className='w-[100%] flex justify-between  px-4 py-2 bg-[#e0e0e04b] rounded-t-[20px] mt-4'>
                    <div className='flex items-center text-[#576071] font-semibold gap-3 dark:text-[#fff] '>
                        <RiCollapseDiagonalLine />
                        Filter Records
                    </div>
                    <div className='flex items-center text-[#576071] font-semibold gap-3 dark:text-[#fff] '>
                        {showfilter ? <IoIosArrowDown /> : <IoIosArrowUp />}
                    </div>
                </div>
                {showfilter &&
                    <div className='bg-[#edf1f5] py-2 px-4 w-[100%] dark:bg-[#121519]'>
                        <div className='w-[100%] flex flex-wrap gap-4'>

                            <div className='w-full sm:w-[48%] lg:w-[24%] flex flex-col gap-1'>
                                <label className='text-[#000] text-[12px] font-semibold dark:text-[#fff]'>Domain Name</label>
                                <input
                                    value={DomainName}
                                    onChange={(e) => setDomainName(e.target.value)}
                                    className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff]'
                                    type="text"
                                />
                            </div>
                            <div className='w-full sm:w-[48%] lg:w-[24%] flex flex-col gap-1'>
                                <label className='text-[#000] text-[12px] font-semibold dark:text-[#fff]'>Domain Provider</label>
                                <select
                                    value={DomainProvider}
                                    onChange={(e) => setDomainProvider(e.target.value)}
                                    className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 dark:bg-[#121519] dark:text-[#fff]'
                                >
                                    <option value="">Select Domain Provider</option>
                                    <option value="1">GoDaddy</option>
                                    <option value="2">Namecheap</option>
                                    <option value="3">Google Domains</option>
                                    <option value="4">Bluehost</option>
                                    <option value="5">HostGator</option>
                                    <option value="6">BigRock</option>
                                    <option value="7">Cloudflare</option>
                                    <option value="8">AWS Route 53</option>
                                    <option value="9">DreamHost</option>
                                    <option value="10">IONOS</option>
                                    <option value="11">Dynadot</option>
                                    <option value="12">Network Solutions</option>
                                    <option value="13">Other</option>
                                </select>
                            </div>
                            <div className='w-full sm:w-[48%] lg:w-[24%] flex flex-col gap-1'>
                                <label className='text-[#000] text-[12px] font-semibold dark:text-[#fff]'>Type</label>
                                <select
                                    value={Domaintype}
                                    onChange={(e) => setDomaintype(e.target.value)}
                                    className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 dark:bg-[#121519] dark:text-[#fff]'
                                >
                                    <option value="">Select Status</option>
                                    <option value="Promotional">Active</option>
                                    <option value="Transactional">In-Active</option>
                                </select>
                            </div>
                            <div className='w-full sm:w-[48%] lg:w-[24%] flex items-center gap-1 mt-4'>
                                <button
                                    onClick={() => getdata()}
                                    className='flex items-center justify-center border-[1px] border-[#37715d] rounded-lg p-2 text-[#37715d] gap-2 hover:bg-[#37715d] hover:text-[#fff] w-full sm:w-auto'
                                >
                                    <FaFilter /> <span className='text-[12px] font-bold'>Filter</span>
                                </button>

                                <button
                                    className='flex items-center justify-center border-[1px] border-[#3f7fca] rounded-lg p-2 text-[#3f7fca] gap-2 hover:bg-[#3f7fca] hover:text-[#fff] w-full sm:w-auto'
                                >
                                    <TbReload /> <span className='text-[12px] font-bold'>Clear Filter</span>
                                </button>
                            </div>

                        </div>
                    </div>
                }
                <table className="w-full   overflow-hidden border-[1px] border-[#dee2e6] ">
                    <thead className="">
                        <tr className="text-left text-sm font-semibold text-gray-700">
                            <th className="p-2  cursor-pointer border-[1px] border-[#dee2e6] ">
                                <div className="flex justify-between items-center gap-2">
                                    <span className='text-[11px] text-[#576071] dark:text-[#fff]'>UserName</span>
                                    <button type="button" className="text-gray-500 hover:text-black">
                                        <TbArrowsSort />
                                    </button>
                                </div>
                            </th>
                            <th className="p-2  cursor-pointer border-[1px] border-[#dee2e6] ">
                                <div className="flex justify-between items-center gap-2">
                                    <span className='text-[11px] text-[#576071] dark:text-[#fff]'>SenderId</span>
                                    <button type="button" className="text-gray-500 hover:text-black">
                                        <TbArrowsSort />
                                    </button>
                                </div>
                            </th>
                            <th className="p-2  cursor-pointer border-[1px] border-[#dee2e6] ">
                                <div className="flex justify-between items-center gap-2">
                                    <span className='text-[11px] text-[#576071] dark:text-[#fff]'>Purpose</span>
                                    <button type="button" className="text-gray-500 hover:text-black">
                                        <TbArrowsSort />
                                    </button>
                                </div>
                            </th>
                            <th className="p-2  cursor-pointer border-[1px] border-[#dee2e6] ">
                                <div className="flex justify-between items-center gap-2">
                                    <span className='text-[11px] text-[#576071] dark:text-[#fff]'>Type</span>
                                    <button type="button" className="text-gray-500 hover:text-black">
                                        <TbArrowsSort />
                                    </button>
                                </div>
                            </th>
                            <th className="p-2  cursor-pointer border-[1px] border-[#dee2e6] ">
                                <div className="flex justify-between items-center gap-2">
                                    <span className='text-[11px] text-[#576071] dark:text-[#fff]'>Status</span>
                                    <button type="button" className="text-gray-500 hover:text-black">
                                        <TbArrowsSort />
                                    </button>
                                </div>
                            </th>


                        </tr>
                    </thead>

                    <tbody>
                        <tr class="text-center text-gray-500 bg-[#f6f9fc] dark:bg-[#121519]">
                            <td colspan="5" className="p-1 text-[11px]">
                                No data found
                            </td>
                        </tr>
                    </tbody>
                </table>
                <p className='text-[11px] text-[#3f7fc8] mt-2' >Showing 1 to 0 of 0 records</p>
            </div>
            <AdduserModal isOpen={open} onClose={() => setOpen(false)} heading={'Domain'} >

                <div className=' py-1 px-4 w-[100%] dark:bg-[#121519]'>
                    <div className='w-[100%] flex flex-wrap gap-2'>
                        <div className='w-full  flex flex-col gap-1'>
                            <label className='text-[#000] text-[12px] font-semibold dark:text-[#fff]'>Domain Name:</label>
                            <input
                                value={NewDomainName}
                                onChange={(e) => setNewDomainName(e.target.value)}
                                placeholder='Enter Domain Name'
                                className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff]'
                                type="text"
                            />
                        </div>
                        <div className='w-full  flex flex-col gap-1'>
                            <label className='text-[#000] text-[12px] font-semibold dark:text-[#fff]'>Domain Provider:</label>
                            <select
                                value={NewDomainProvider}
                                onChange={(e) => setNewDomainProvider(e.target.value)}
                                className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 dark:bg-[#121519] dark:text-[#fff]'
                            >
                                <option value="">Select Domain Provider</option>
                                <option value="1">GoDaddy</option>
                                <option value="2">Namecheap</option>
                                <option value="3">GoogleDomains</option>
                                <option value="4">Bluehost</option>
                                <option value="5">HostGator</option>
                                <option value="6">BigRock</option>
                                <option value="7">Cloudflare</option>
                                <option value="8">AWSRoute53</option>
                                <option value="9">DreamHost</option>
                                <option value="10">IONOS</option>
                                <option value="11">Dynadot</option>
                                <option value="12">NetworkSolutions</option>
                                <option value="13">Other</option>
                            </select>
                        </div>
                        <div className='flex items-center w-[100%] gap-4'>
                            <button
                                onClick={() => setisActive(!isActive)}
                                className={`w-[25px] h-[12px] flex items-center rounded-[50px] transition duration-300 ${isActive ? "bg-[#37715d]" : "bg-[#b4bbc3]"}`}>
                                <div
                                    className={`bg-[#fff] w-[10px] h-[10px] rounded-full shadow-md transform transition ml-[1px] ${isActive ? "translate-x-[13px]" : ""}`}>
                                </div>
                            </button>
                            <span className='text-[#b4bbc3] text-[12px]'>Is Active</span>
                        </div>
                        <div className='w-full  flex items-center justify-end gap-1 mt-4'>
                            <button
                                className='flex items-center justify-center border-[1px] border-[#37715d] rounded-lg p-2  gap-2 bg-[#37715d] text-[#fff] w-full sm:w-auto'
                            >
                                <span className='text-[12px] font-bold'>Save</span>
                            </button>

                            <button
                                onClick={() => {
                                    setOpen(!open)
                                }}
                                className='flex items-center justify-end border-[1px] border-[#3f7fca] rounded-lg p-2 text-[#3f7fca] gap-2 hover:bg-[#3f7fca] hover:text-[#fff] w-full sm:w-auto'
                            >
                                <span className='text-[12px] font-bold'>Close</span>
                            </button>
                        </div>
                    </div>
                </div>
            </AdduserModal>
        </>
    )
}

export default DomainSmartLink
